<template>
<div class="results_text">
            <div class="results_testing">
                <h3 class="testing">9600 ELISA test systems for identifying COVID 19 were purchased with the funding by the Center European Initiative (CEI) within the Project Stop COVID19. The total contribution is 10,000 EUR. Now the research is being conducted at the
                    specialized laboratories of Lviv Region.</h3>
            </div>
</div>

</template>

<script>
export default {
  name: 'Results_Text',
   
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>.results_text {
  display: -ms-grid;
  display: grid;
  -ms-grid-columns: 10% (minmax(10px, 1fr))[10] 10%;
      grid-template-columns: 10% repeat(10, minmax(10px, 1fr)) 10%;
  -ms-grid-rows: 1fr;
      grid-template-rows: 1fr;
  background-color: #A80315;
  color: white;
}

.results_testing {
  text-align: center;
  -ms-grid-column: 2;
  -ms-grid-column-span: 10;
  grid-column: 2/12;
  padding: 80px;
}

.results_testing .testing {
  font-size: 30px;
  font-weight: 600;
}

@media only screen and (max-width: 415px) {
  .results_text {
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: 10% (minmax(10px, 1fr))[10] 10%;
        grid-template-columns: 10% repeat(10, minmax(10px, 1fr)) 10%;
    -ms-grid-rows: 1fr;
        grid-template-rows: 1fr;
    background-color: #A80315;
    color: white;
  }
  .results_testing {
    text-align: center;
    -ms-grid-column: 1;
    -ms-grid-column-span: 12;
    grid-column: 1/13;
    padding: 30px;
  }
  .results_testing .testing {
    font-size: 14px;
    font-weight: 500;
  }
}

@media only screen and (min-width: 415px) and (max-width: 768px) {
  .results_text {
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: 10% (minmax(10px, 1fr))[10] 10%;
        grid-template-columns: 10% repeat(10, minmax(10px, 1fr)) 10%;
    -ms-grid-rows: 1fr;
        grid-template-rows: 1fr;
    background-color: #A80315;
    color: white;
  }
  .results_testing {
    text-align: center;
    -ms-grid-column: 2;
    -ms-grid-column-span: 10;
    grid-column: 2/12;
    padding: 30px;
  }
  .results_testing .testing {
    font-size: 24px;
    font-weight: 500;
  }
}
</style>
